import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "input",
    "newUserPanel",
    "existingUserPanel",
    "newUserTab",
    "existingUserTab",
    "referentSection",
    "referentMessage",
    "descriptionBase",
    "descriptionWithReferent"
  ]

  connect () {
    this.updatePreviews()
  }

  updatePreviews () {
    const message = this.inputTarget.value.trim()
    const hasMessage = message.length > 0

    this.referentMessageTargets.forEach((element) => {
      element.textContent = message
    })

    this.referentSectionTargets.forEach((element) => {
      element.classList.toggle("d-none", !hasMessage)
    })

    this.descriptionBaseTargets.forEach((element) => {
      element.classList.toggle("d-none", hasMessage)
    })

    this.descriptionWithReferentTargets.forEach((element) => {
      element.classList.toggle("d-none", !hasMessage)
    })
  }

  showNewUser (event) {
    event.preventDefault()
    this.newUserPanelTarget.classList.remove("d-none")
    this.existingUserPanelTarget.classList.add("d-none")
    this.newUserTabTarget.classList.add("active")
    this.existingUserTabTarget.classList.remove("active")
  }

  showExistingUser (event) {
    event.preventDefault()
    this.newUserPanelTarget.classList.add("d-none")
    this.existingUserPanelTarget.classList.remove("d-none")
    this.newUserTabTarget.classList.remove("active")
    this.existingUserTabTarget.classList.add("active")
  }
}
